import React from 'react'
import ZestawienieHeaderStyle from '../../styles/ZestawienieHeaderStyle'
import BilansSwaper from '../bilans/BilansSwaper'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const ZestawienieHeader = props => {
  return (
    <ZestawienieHeaderStyle>
      <FormControlLabel
        className="checkbox-label"
        control={
          <Checkbox
            color="primary"
            checked={props.isThirdColumn}
            onChange={props.onCheck}
          />
        }
        label="Pokaż kolumnę przekształconych danych za rok poprzedni"
      />
      <div className="list-header">
        <div className="name">NAZWA POZYCJI</div>
        <div className="column-title">ROK BIEŻĄCY</div>
        <div className="column-title">ROK POPRZEDNI</div>
        {props.isThirdColumn && (
          <div className="third column-title">
            PRZEKSZTAŁCONE DANE ZA ROK POPRZEDNI
          </div>
        )}
        <div className="swapper">
          {props.onAktywaClick && props.onPasywaClick ? (
            <BilansSwaper
              onAktywaClick={props.onAktywaClick}
              onPasywaClick={props.onPasywaClick}
            />
          ) : null}
        </div>
      </div>
    </ZestawienieHeaderStyle>
  )
}

export default ZestawienieHeader
